module.exports = __webpack_public_path__ + "img/twittericon.089d2d6a.svg";